<template>
  <el-button-group class="sort-controller">
    <el-button
      v-for="option of options"
      :key="option.icon"
      :type="value === option.value ? 'primary' : 'default'"
      :icon="option.icon"
      :title="option.title"
      @click="submit(option.value)"
    />
  </el-button-group>
</template>

<script>
import { t } from '@/locale'

export default {
  name: 'SortController',
  props: {
    value: {
      default: false
    }
  },
  data() {
    return {
    }
  },
  computed: {
    options() {
      return [
        {
          value: 'asc',
          icon: 'el-icon-sort-up',
          title: t('table.toolbar.sortUp')
        },
        {
          value: '',
          icon: 'el-icon-close',
          title: t('table.toolbar.default')
        },
        {
          value: 'desc',
          icon: 'el-icon-sort-down',
          title: t('table.toolbar.sortDown')
        }
      ]
    }
  },
  methods: {
    submit(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.sort-controller {
  .el-button {
    padding: 2px;
    font-size: 10px;
  }
}
</style>
